export default "__VITE_ASSET__Y0e3n6x$IKZ99CSNseB1Zw__"